module.exports = __webpack_public_path__ + "static/media/display-suite-04.4a6f68bf.jpg";